module.exports = __webpack_public_path__ + "static/media/krispcall.152fd45c.webp";